export default "__VITE_ASSET__eQ0WSljY__"